<template>
  <v-container id="vesselViewCont" fluid fill-height grid-list-md style="padding:0px 10px 5px 10px;width:100%;">
    <v-layout v-if="twinLayout" row v-show="load">
      <v-flex d-flex md3>
        <VesselInfo v-bind:vesselData="vesselData"/>
      </v-flex>
      <v-flex d-flex md9>
        <v-layout column>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-layout row>
              <v-flex d-flex md6>
                <FaultsTwinWidget v-bind:navigation="true" v-bind:engine="'Port'" :title="'Port Engine Faults'"/>
              </v-flex>
              <v-flex d-flex md6>
                <FaultsTwinWidget v-bind:navigation="true" v-bind:engine="'Stbd'" :title="'Stbd Engine Faults'"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-layout row>
              <v-flex d-flex md6>
                <PerformanceWidget v-bind:cardData="cardData['Port']" :title="'Port Engine Performance'" :engine="'Port'"/>
              </v-flex>
              <v-flex d-flex md6>
                <PerformanceWidget v-bind:cardData="cardData['Stbd']" :title="'Stbd Engine Performance'" :engine="'Stbd'"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout v-else row v-show="load">
      <v-flex d-flex md3>
        <VesselInfo v-bind:vesselData="vesselData"/>
      </v-flex>
      <v-flex d-flex md9>
        <v-layout column fill-height>
          <v-flex d-flex md6 style="max-height:50%;">
            <v-layout row style="">
              <v-flex d-flex md3 style="max-height: 100%; display: inline-block !important; width: 100%;">
                <div style="max-height: 50%;min-height:50%;" ref="gaugeContainer">
                  <Gauge v-bind:data="gaugeData['ensp']" :height="gaugeHeight"/>
                </div>
                <div style="max-height: 50%;min-height:50%;">
                  <Gauge v-bind:data="gaugeData['load']" :height="gaugeHeight"/>
                </div>
              </v-flex>
              <v-flex d-flex md3>
                <EngineState v-bind:data="engineData"/>
              </v-flex>
              <v-flex d-flex md6>
                <SubsystemState v-bind:data="subSystemData"/>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex d-flex md6 style="max-height:50%; padding-bottom: 0px !important;">
            <v-layout row style="margin-bottom: -8px;">
              <v-flex d-flex md6>
                <PerformanceWidget v-bind:navigation="true" v-bind:cardData="cardData" v-bind:gaugeData="gaugeData" :title="'Engine Performance'"/>
              </v-flex>
              <v-flex d-flex md6>
                <FaultsWidget v-bind:navigation="true"/>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
/* eslint-disable no-console */

import VesselInfo from '../controls/VesselInfo'
import EngineState from '../controls/EngineState'
import SubsystemState from '../controls/SubsystemState'
import PerformanceWidget from '../controls/PerformanceWidget'
import FaultsWidget from '../controls/FaultsWidget'
import FaultsTwinWidget from '../controls/FaultsTwinWidget'
import Gauge from '../controls/Gauge'

import {globalStore} from "../main.js"

export default {
  name: "VesselView",
  components: {
    VesselInfo,
    SubsystemState,
    EngineState,
    PerformanceWidget,
    FaultsWidget,
    FaultsTwinWidget,
    Gauge
  },
  data: function () {
    return {
      cardData: {},
      subSystemData: [],
      engineData: {},
      gaugeData: {},
      vesselData: {},
      gaugeHeight: 203,
      load: false,
      ro: null
    }
  },
  beforeDestroy() {
    if (this.ro != null)
      this.ro.unobserve(this.$refs['gaugeContainer']);
  },
  methods: {
    average: function (param, count, data, timestamp) {
      let sum = 0;

      for (let i = 1; i <= count; i++) {
        if (typeof data[timestamp] != 'undefined' && data[timestamp][param + i] != -1000)
          sum += data[timestamp][param + i];
        else
          count--;
      }

      if (sum == 0 || count == 0)
        return -1000;
      else
        return sum / count;
    },
    setData() {
      this.cardData['canNav'] = false;
      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      this.load = false;

      if (typeof globalStore.reference.timestamps == 'undefined' && typeof globalStore.signals.timestamps == 'undefined') {
        return;
      }

      let refLength = (globalStore.reference.timestamps||[]).length,
          sigLength = (globalStore.signals.timestamps||[]).length;

      var temp;

      if (refLength > sigLength)
        temp = globalStore.signals.timestamps;
      else
        temp = globalStore.reference.timestamps;

      let timestamp = ((refLength > sigLength) ? this.fetchDateFromSignal('signals') : this.fetchDateFromSignal('reference'));

      if (typeof temp == 'undefined') {
        if (refLength < sigLength)
          temp = globalStore.signals.timestamps;
        else
          temp = globalStore.reference.timestamps;

        timestamp = ((refLength < sigLength) ? this.fetchDateFromSignal('signals') : this.fetchDateFromSignal('reference'));
      }

      let last = Math.max.apply(Math, temp);

      if (temp.indexOf('average') > -1)
        temp.splice(temp.indexOf('average'), 1);

      if (temp.indexOf('average') > -1)
        temp.splice(temp.indexOf('average'), 1);

      //vessel data
      this.$set(this.vesselData, 'showMap', false);

      if (typeof last != 'undefined') {
        this.$set(this.vesselData, 'timeStamp', {
          label: 'Timestamp',
          value: new Date(parseInt(last)).toISOString().substring(0, 16).replace('T', ' '),
          unit: '',
          format: null
        });
      }

      if (globalStore.type != 'last' && globalStore.type != 'today' && temp.length) {
        this.vesselData['timeStamp'].value = new Date(temp[temp.length - 2]).toISOString().slice(0, 10);
      }

      if (typeof globalStore.dateTo != 'undefined' && globalStore.dateTo.length) {
        try {
          this.vesselData['timeStamp'].value = globalStore.signals.signalDate;
        } catch (e) {
          this.vesselData['timeStamp'].value = globalStore.type + ' - ' + globalStore.dateTo;
        }
      }

      let params = ['LAT', 'LON'];

      for (let p = 0; p < params.length; p++) {
        this.$set(this.vesselData, params[p], {
          label: mapping['mapping'][params[p]],
          value: ((typeof globalStore.signals[last] != 'undefined') ? globalStore.signals[last][params[p]] : -1000),
          unit: '[' + units[params[p]] + ']',
          format: 2
        });
      }

      params = ['ME_Torque_perc', 'ME_Power_perc', 'ensp', 'STW', 'SOG', 'Slip_STW', 'Slip_SOG', 'COG', 'Wind_Speed', 'Wind_direction_relative', 'Water_Depth', 'Rudder_angle'];

      for (let p = 0; p < params.length; p++) {
        this.$set(this.vesselData, params[p], {
          label: mapping['mapping'][params[p]],
          value: ((typeof globalStore.signals[timestamp] != "undefined") ? globalStore.signals[timestamp][params[p]] : -1000),
          unit: '[' + units[params[p]] + ']',
          format: 2
        });
      }

      if (typeof globalStore.signals[timestamp] != 'undefined' && typeof globalStore.signals[timestamp]['load'] != 'undefined' && this.vesselData['ME_Power_perc'].value == -1000 && globalStore.signals[timestamp]['load'] != -1000)
        this.vesselData['ME_Power_perc'].value = globalStore.signals[timestamp]['load'] * 100;

      this.$set(this.vesselData, 'route', []);
      let timeStamps = globalStore.signals.timestamps;

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      params = ['ME_Power_perc', 'ensp', 'STW'];

      this.$set(this.vesselData, 'points', []);

      for (let i = 0; i < timeStamps.length; i++) {
        if (globalStore.signals[timeStamps[i]]['LON'] != -1000) {
          // let dt = new Date(timeStamps[i]);

          // let html = '<b>' + dt.toISOString().substring(0,10) + '</b>';

          this.vesselData.route.push({
            'coords': [globalStore.signals[timeStamps[i]]['LON'], globalStore.signals[timeStamps[i]]['LAT']],
            //  'html': html
          });
        }
      }

      if (this.vesselData.route.length > 0)
        this.vesselData.route[0].points = true;

      if (typeof globalStore.signals[last] != 'undefined' && globalStore.signals[last]['LAT'] != -1000) {
        let dt = new Date(last);

        let html = '<b>' + dt.toISOString().substring(0, 10) + ' ' + globalStore.selectedVessel + '</b><br>';

        for (let p = 0; p < params.length; p++) {
          if (typeof globalStore.signals[last][params[p]] != 'undefined') {
            if (globalStore.signals[last][params[p]] != -1000)
              html += mapping['mapping'][params[p]] + ': ' + globalStore.signals[last][params[p]].toFixed(2) + ' [' + units[params[p]] + ']<br>';
            else if (params[p] == 'ME_Power_perc' && globalStore.signals[last]['load'] != -1000)
              html += mapping['mapping'][params[p]] + ': ' + (globalStore.signals[last]['load'] * 100).toFixed(2) + ' [' + units[params[p]] + ']<br>';
            else
              html += mapping['mapping'][params[p]] + ': - [' + units[params[p]] + ']<br>';
          }
        }

        // html += 'Faults: 0<br>Tickets: -';

        this.vesselData['points'].push({
          'coords': [globalStore.signals[last]['LON'], globalStore.signals[last]['LAT']],
          'html': html,
          'last': true
        });
      }

      this.$set(this.vesselData, 'showMap', true);

      //KPIs

      let kpi = 0;
      this.engineData = {};

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        this.$set(this.engineData, 'engineColor', globalStore.reference[timestamp]['eng_KPI_color']);

        kpi = globalStore.reference[timestamp]['eng_KPI'] * 100;
      }

      if (kpi.toFixed(1) != '100.0')
        this.$set(this.engineData, 'engineKPI', kpi.toFixed(1));
      else
        this.$set(this.engineData, 'engineKPI', kpi.toFixed(0));

      this.engineData.cylinders = [];

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        for (let c = 1; c <= this.cylCount; c++)
          this.engineData.cylinders.push(globalStore.reference[timestamp]['cyl' + c + '_KPI_color']);
      } else {
        for (let c = 1; c <= this.cylCount; c++)
          this.engineData.cylinders.push(-1000);
      }

      let names = ['Turbines', 'Compressors', 'A/F', 'A/C'],
          tags = ['turb', 'comp', 'ac', 'af'];

      this.engineData.elements = [];

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        for (let el = 0; el < names.length; el++) {
          let sum = 0;

          for (let t = 1; t <= this.tcCount; t++) {
            sum += globalStore.reference[timestamp][tags[el] + t + '_KPI_color'];
          }

          this.engineData.elements.push({
            name: names[el],
            color: sum / this.tcCount
          });
        }
      } else {
        for (let el = 0; el < names.length; el++) {
          this.engineData.elements.push({
            name: names[el],
            color: -1000
          });
        }
      }

      this.subSystemData = [];
      if (globalStore.gasEngine) {
        names = [['Servo Oil', 'Exhaust Gas', 'Piston Running'], ['Fuel Injection', 'Scavenge Air', 'Gas Admission'], ['Automation & Control']];
        tags = [['so_KPI_color', 'egs_KPI_color', 'pr_KPI_color'], ['fi_KPI_color', 'sac_KPI_color', 'gas_KPI_color'], ['ca_KPI_color']];
      } else {
        names = [['Servo Oil', 'Exhaust Gas', 'Piston Running'], ['Fuel Injection', 'Scavenge Air', 'Automation & Control']];
        tags = [['so_KPI_color', 'egs_KPI_color', 'pr_KPI_color'], ['fi_KPI_color', 'sac_KPI_color', 'ca_KPI_color']];
      }

      if (typeof globalStore.reference[timestamp] != 'undefined') {
        for (let col = 0; col < names.length; col++) {
          let column = [];

          for (let sys = 0; sys < names[col].length; sys++) {
            column.push({
              system: names[col][sys],
              value: globalStore.reference[timestamp][tags[col][sys]]
            });
          }
          this.subSystemData.push(column);
        }
      } else {
        for (let col = 0; col < names.length; col++) {
          let column = [];

          for (let sys = 0; sys < names[col].length; sys++) {
            column.push({
              system: names[col][sys],
              value: -1000
            });
          }
          this.subSystemData.push(column);
        }
      }

      let customTicks = [];
      for (let i = 10; i <= 110; i += 10) {
        customTicks.push(i);
      }

      //gauges
      console.log(globalStore.signals[timestamp]['ME_Power_perc'])
      if (typeof globalStore.signals[timestamp] != 'undefined') {
        this.$set(this.gaugeData, 'load', {
          value: globalStore.signals[timestamp]['ME_Power_perc'],
          rangeLimit: 100,
          startValue: 10,
          endValue: 110,
          customTicks: customTicks,
          format: 1,
          unit: '[' + units['ME_Power_perc'] + ']',
          title: mapping['mapping']['ME_Power_perc']
        });

        if ((typeof this.gaugeData['load'].value == 'undefined' || this.gaugeData['load'].value == -1000) && globalStore.signals[timestamp]['load'] != -1000)
          this.gaugeData['load'].value = globalStore.signals[timestamp]['load'] * 100;
      }

      let rpmMcr = Math.round(globalStore.loadDiagram['otVal2']),
          intNum = 10,
          lowSpeed = rpmMcr / 2,
          step = Math.ceil(lowSpeed / (intNum - 2)),
          tick = rpmMcr - (intNum - 1) * step;

      customTicks = [];
      customTicks.push(tick);

      if (typeof globalStore.signals[timestamp] != 'undefined') {
        for (let i = 0; i < intNum; i++) {
          tick += step;
          customTicks.push(tick);
        }

        this.$set(this.gaugeData, 'ensp', {
          value: globalStore.signals[timestamp]['ensp'],
          rangeLimit: rpmMcr,
          startValue: customTicks[0],
          endValue: customTicks[intNum],
          tickInterval: step,
          customTicks: customTicks,
          format: 1,
          unit: '[rpm]',
          title: 'Engine Speed'
        });

        this.$set(this.gaugeData, 'bsfc', {
          value: globalStore.signals[timestamp]['bsfc'],
          rangeLimit: 190,
          startValue: 150,
          endValue: 210,
          tickInterval: 10,
          format: 1,
          unit: '[g/kWh]',
          title: 'SFOC'
        });

        //performance Data
        params = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'];
        let refs = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'],
            elCount = [this.cylCount, this.cylCount, this.tcCount, this.tcCount, 0, 0];

        for (let p = 0; p < params.length; p++) {
          let val, rfr;

          if (typeof globalStore.reference[timestamp] != 'undefined' && typeof globalStore.signals[timestamp] != 'undefined') {
            if (elCount[p] > 0)
              val = this.average(params[p], elCount[p], globalStore.signals, timestamp);
            else
              val = globalStore.signals[timestamp][params[p]];

            if (elCount[p] > 0)
              rfr = this.average(refs[p], elCount[p], globalStore.reference, timestamp);
            else
              rfr = globalStore.reference[timestamp][refs[p]];
          } else {
            val = -1000;
            rfr = -1000;
          }

          if (isNaN(val))
            val = -1000;

          if (isNaN(rfr))
            rfr = -1000;

          let color = -10;

          if (val != -1000 && rfr != -1000 && Object.keys(limits).includes(params[p])) {
            let minLimit = limits[params[p]][0], maxLimit = limits[params[p]][1],
                temp = ((val - rfr) / val) * 100;

            if (temp > minLimit && temp < maxLimit)
              color = 0;
            else
              color = 20;
          }

          this.$set(this.cardData, params[p], {
            value: val,
            ref: rfr,
            title: mapping['mapping'][params[p]],
            unit: units[params[p]],
            format: 2,
            color: color
          });
        }

        this.cardData['canNav'] = true;
        globalStore.loading = false;
        this.load = true;
      }
    },
    setTwinData() {
      let twinSignals_invalid = typeof globalStore.twinSignals == 'undefined' || Object.keys(globalStore.twinSignals).length < 1,
          twinReference_invalid = typeof globalStore.twinReference == 'undefined' || Object.keys(globalStore.twinReference).length < 1;

      console.log(twinSignals_invalid, twinReference_invalid)

      if (twinSignals_invalid || twinReference_invalid) {
        return;
      }

      var mapping = globalStore.mapping[globalStore.selectedIMO],
          units = globalStore.units[globalStore.selectedIMO],
          limits = globalStore.limits[globalStore.selectedIMO];

      if (typeof mapping == 'undefined') {
        mapping = globalStore.mapping[Object.keys(globalStore.mapping)[0]]
      }

      if (typeof units == 'undefined') {
        units = globalStore.units[Object.keys(globalStore.units)[0]]
      }

      if (typeof limits == 'undefined') {
        limits = globalStore.limits[Object.keys(globalStore.limits)[0]]
      }

      this.load = false;

      let engine_source = 'Port';

      if (typeof globalStore.twinSignals['Port'] == 'undefined' && typeof globalStore.twinReference['Port'] == 'undefined') {
        engine_source = 'Stbd';
      }

      let temp = Object.keys(globalStore.twinSignals[engine_source]).filter(value => -1 !== Object.keys(globalStore.twinReference[engine_source]).indexOf(value)),
          refLength = Object.keys(globalStore.twinReference[engine_source]).length,
          sigLength = Object.keys(globalStore.twinSignals[engine_source]).length,
          dataSource = ((refLength > sigLength) ? globalStore.twinSignals[engine_source] : globalStore.twinReference[engine_source]),
          timestamp = dataSource['lastDate'],
          timestamp_display = Math.max.apply(this, dataSource['timestamps']);

      console.log(timestamp_display)

      if (temp.indexOf('average') > -1)
        temp.splice(temp.indexOf('average'), 1);

      //vessel data
      this.$set(this.vesselData, 'showMap', false);
      this.$set(this.vesselData, 'timeStamp', {
        label: 'Timestamp',
        value: new Date(parseInt(timestamp_display)).toISOString().substring(0, 16).replace('T', ' '),
        unit: '',
        format: null
      });

      if ((globalStore.type != 'last') && (globalStore.type != 'today')) {
        this.vesselData['timeStamp'].value = new Date(timestamp_display).toISOString().slice(0, 10);
      }

      if (typeof globalStore.dateTo != 'undefined' && globalStore.dateTo.length) {
        this.vesselData['timeStamp'].value = globalStore.type + ' - ' + globalStore.dateTo;
      }

      let params = ['LAT', 'LON'];

      for (let p = 0; p < params.length; p++) {
        this.$set(this.vesselData, params[p], {
          label: mapping['mapping'][params[p]],
          value: ((typeof globalStore.twinSignals[engine_source][timestamp] != 'undefined') ? globalStore.twinSignals[engine_source][timestamp][params[p]] : -1000),
          unit: '[' + units[params[p]] + ']',
          format: 2
        });
      }

      params = ['ME_Torque_perc', 'ME_Power_perc', 'ensp'];

      for (let p = 0; p < params.length; p++) {
        let vP, vS;        

        if (globalStore.twinSignals['Port'] && typeof globalStore.twinSignals['Port'][timestamp] != 'undefined')
          vP = globalStore.twinSignals['Port'][timestamp][params[p]].toFixed(2);
        else
          vP = -1000;        

        if (typeof globalStore.twinSignals['Stbd'][timestamp] != 'undefined')
          vS = globalStore.twinSignals['Stbd'][timestamp][params[p]].toFixed(2);
        else
          vS = -1000;

        if (params[p]=='ME_Power_perc')
        {
          if ((vP==-1000)&&(globalStore.twinSignals['Port']) && (typeof globalStore.twinSignals['Port'][timestamp] != 'undefined') && (globalStore.twinSignals['Port'][timestamp]['load'] != -1000))
            vP = (globalStore.twinSignals['Port'][timestamp]['load'] * 100).toFixed(2) ;
          
          if ((vS==-1000)&&(globalStore.twinSignals['Stbd']) && (typeof globalStore.twinSignals['Stbd'][timestamp] != 'undefined') && (globalStore.twinSignals['Stbd'][timestamp]['load'] != -1000))
            vS = (globalStore.twinSignals['Stbd'][timestamp]['load'] * 100).toFixed(2) ;
        }

        if (vP == -1000)
          vP = '-';

        if (vS == -1000)
          vS = '-';

        this.$set(this.vesselData, params[p], {
          label: mapping['mapping'][params[p]],
          valuePort: vP,
          valueStbd: vS,
          unit: '[' + units[params[p]] + ']',
          format: 2
        });
      }

      params = ['STW', 'SOG', 'Slip_STW', 'Slip_SOG', 'COG', 'Wind_Speed', 'Wind_direction_relative', 'Water_Depth', 'Rudder_angle'];

      for (let p = 0; p < params.length; p++) {
        var value;

        try {
          value = globalStore.twinSignals[engine_source][timestamp][params[p]];
        } catch (e) {
          value = -1000;
        }

        this.$set(this.vesselData, params[p], {
          label: mapping['mapping'][params[p]],//params[p],
          value: value,
          unit: '[' + units[params[p]] + ']',
          format: 2
        });
      }


      this.$set(this.vesselData, 'route', []);
      let timeStamps = globalStore.twinSignals[engine_source].timestamps;

      if (timeStamps.indexOf('average') > -1)
        timeStamps.splice(timeStamps.indexOf('average'), 1);

      params = ['ME_Power_perc', 'ensp', 'STW'];

      for (let i = 0; i < timeStamps.length; i++) {
        if (globalStore.twinSignals[engine_source][timeStamps[i]]['LON'] != -1000) {
          this.vesselData.route.push({
            'coords': [globalStore.twinSignals[engine_source][timeStamps[i]]['LON'], globalStore.twinSignals[engine_source][timeStamps[i]]['LAT']],
          });
        }
      }

      this.$set(this.vesselData, 'points', []);

      if (typeof globalStore.twinSignals[engine_source][timestamp] != 'undefined' && globalStore.twinSignals[engine_source][timestamp]['LAT'] != -1000) {
        let html = '<b>' + timestamp + ' ' + globalStore.selectedVessel + '</b><br>';

        for (let p = 0; p < params.length; p++) {
          if (params[p] == 'STW') {
            if (globalStore.twinSignals[engine_source][timestamp][params[p]] != -1000)
              html += mapping['mapping'][params[p]] + ': ' + globalStore.twinSignals[engine_source][timestamp][params[p]].toFixed(2) + ' [' + units[params[p]] + ']<br>';
            else
              html += mapping['mapping'][params[p]] + ': - [' + units[params[p]] + ']<br>';
          } else {
            let vP, vS;

            try {
              vP = globalStore.twinSignals[engine_source][timestamp][params[p]].toFixed(2);
            } catch (e) {
              vP = -1000;
            }
            try {
              vS = globalStore.twinSignals['Stbd'][timestamp][params[p]].toFixed(2);
            } catch (e) {
              vS = -1000;
            }

            if (vP == -1000)
              vP = '-';

            if (vS == -1000)
              vS = '-';

            html += mapping['mapping'][params[p]] + ': ' + vP + ' (port) ' + vS + ' (stbd) [' + units[params[p]] + ']<br>';
          }
        }

        html += 'Faults: 0<br>Tickets: -';

        this.vesselData['points'].push({
          'coords': [globalStore.twinSignals[engine_source][timestamp]['LON'], globalStore.twinSignals[engine_source][timestamp]['LAT']],
          'html': html,
          'last': true
        });
      }

      this.$set(this.vesselData, 'showMap', true);


      //performance Data
      params = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'];

      let engines = ['Port', 'Stbd'],
          refs = ['pcomp', 'pmax', 'tcspeed', 'tTurbIn', 'pscav', 'bsfc'],
          elCount = [this.cylCount, this.cylCount, this.tcCount, this.tcCount, 0, 0];

      engines.forEach(eng => {
        if (typeof globalStore.twinSignals[eng] != 'undefined') {
          this.cardData[eng] = {};

          temp = Object.keys(globalStore.twinSignals[eng]).filter(value => -1 !== Object.keys(globalStore.twinReference[eng]).indexOf(value));
          timestamp = ((refLength > sigLength) ? globalStore.twinSignals[eng]['lastDate'] : globalStore.twinSignals[eng]['lastDate']);

          for (let p = 0; p < params.length; p++) {
            let val, rfr,
                color = -10;

            if (typeof globalStore.twinSignals[eng][timestamp] != 'undefined' && typeof globalStore.twinReference[eng][timestamp] != 'undefined') {
              if (elCount[p] > 0)
                val = this.average(params[p], elCount[p], globalStore.twinSignals[eng], timestamp);
              else
                val = globalStore.twinSignals[eng][timestamp][params[p]];

              if (elCount[p] > 0)
                rfr = this.average(refs[p], elCount[p], globalStore.twinReference[eng], timestamp);
              else
                rfr = globalStore.twinReference[eng][timestamp][refs[p]];
            } else {
              val = -1000;
              rfr = -1000;
            }

            if (isNaN(val))
              val = -1000;

            if (isNaN(rfr))
              rfr = -1000;

            if ((val != -1000) && (rfr != -1000) && (Object.keys(limits).includes(params[p]))) {
              let minLimit = limits[params[p]][0],
                  maxLimit = limits[params[p]][1],
                  temp = ((val - rfr) / val) * 100;

              if (temp > minLimit && temp < maxLimit)
                color = 0;
              else
                color = 20;
            }

            this.$set(this.cardData[eng], params[p], {
              value: val,
              ref: rfr,
              title: mapping['mapping'][params[p]],
              unit: units[params[p]],
              format: 2,
              color: color
            });
            this.$set(this.cardData[eng], 'canNav', true);
          }
        } else {
          this.cardData[eng] = {};

          for (let p = 0; p < params.length; p++) {
            this.$set(this.cardData[eng], params[p], {
              value: -1000,
              ref: -1000,
              title: mapping['mapping'][params[p]],
              unit: units[params[p]],
              format: 2,
              color: -10
            });
          }
          this.$set(this.cardData[eng], 'canNav', false);
        }
      });

      globalStore.loading = false;
      this.load = true;
    },
    onResize: function () {
      if (typeof this.$refs['gaugeContainer'] != 'undefined') {
        this.gaugeHeight = this.$refs['gaugeContainer'].clientHeight - 50;
      }
    },
    fetchDateFromSignal(key) {
      if (typeof globalStore[key] != 'undefined') {
        if (Object.keys(globalStore[key]).indexOf('average') > -1) {
          return 'average';
        } else {
          return globalStore[key]['lastDate'];
        }
      }
    },
  },
  computed: {
    dataLoaded: function () {
      if (!!globalStore.type) {
        if (!!globalStore.dateTo) {
          return globalStore.type + '-' + globalStore.dateTo;
        } else {
          return globalStore.type;
        }
      } else {
        return '';
      }
    },
    selVessel: function () {
      return globalStore.selectedVessel;
    },
    cylCount: function () {
      return globalStore.cylCount;
    },
    tcCount: function () {
      return globalStore.tcCount;
    },
    twinLayout: function () {
      return globalStore.twinEngine;
    },
    checkedDate: function () {
      return globalStore.checkedDate;
    },
    validDate: function () {
      return globalStore.validDate;
    },
  },
  watch: {
    dataLoaded: {
      handler: function () {
        if (this.dataLoaded != '') {
          if (this.twinLayout) {
            this.setTwinData();
            console.log(this.vesselData)
          } else {
            this.setData();
          }
        }
      },
      deep: true,
      immediate: true
    },
    selVessel: {
      handler: function (a) {
        if (this.twinLayout)
          this.setTwinData();
        else
          this.setData();
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {

    if (this.twinLayout)
      this.setTwinData();
    else {
      this.ro = new ResizeObserver(this.onResize).observe(this.$refs['gaugeContainer']);
      this.setData();
    }

    globalStore.expectingVesselData = false;
    globalStore.loading = false;
  },
}
</script>

<style scoped>

</style>
<style>
</style>
